<script>
/* jshint esversion: 6 */
import {watch, computed, inject } from 'vue';
import './../func.common';
import { FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default{
    name: 'inputFEmail',
    components: {
        'font-awesome-icon' : FontAwesomeIcon
    },
    props: {
        'disabled': {type: Boolean},
        'fullSchema': { type: [Object], default: function() { return {};} }, 
        'hinted': {type: String},
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
    },
    setup(props) {
        const validateChild = inject('validateChild');
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(helperName, () => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator
            };
            if (validateChild) {
                validateChild(toParent);
            }
        });
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .fieldInput(
       :class="[schema.class,disabled === true ? 'fieldDisabled' : ''] "
    )
        .form-group.row.gy-2.gx-3-align-items-left
            .col-sm-12 
                label(
                    :for="id" 
                    v-if="schema.label && schema.label.length > 0"
                ) 
                    |{{ schema.label }} 
                    span.redAst(v-if="schema.required === true") *
        .form-group.row.gx-3-align-items-left(
            :style="disabled === true ? 'cursor: not-allowed; opacity: 0.5' : ''"
        )
            div(:class="schema.buttons ? 'col-sm-9' : 'col-sm-12'")
                input.form-control(
                    :id="id" 
                    :type="schema.inputType" 
                    :name="schema.model" 
                    :value="model[schema.model]" 
                    v-model="model[schema.model]" 
                    maxlength="255" 
                    :style="[disabled === true ? 'pointer-events:none' : '']"
                    :class="[schema.errorShow === true ? 'inputred' : '', model[schema.model] !== '' ? 'getWhite' : 'getBlue']"
                )
            .vueFormSmall.labelred(v-if="schema.errorShow === true")
                font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                | &nbsp; Fehler in der/den E-Mail-Adresse/n
                ul
                    template(v-for="item in schema.errorText")
                        li(v-html="item")
        .hint(v-if="hinted && hinted.length > 0" v-html="hinted") 
</template>